module.exports = __webpack_public_path__ + "img/step_img_02.80ef72bb.webp";